/** @format */

import App from '@templates/App/App';

export default App;

export * from '@templates/App/App';
